export default __webpack_public_path__ + "static/media/alerts-dark.de9ff589.svg";